import { render, staticRenderFns } from "./HomeAccessibility.vue?vue&type=template&id=1ac1ac9e"
import script from "./HomeAccessibility.vue?vue&type=script&lang=js"
export * from "./HomeAccessibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports